import type { CSSProperties, HTMLAttributes } from 'react';
import { cn } from '../cn';
import { iconPaths } from './paths';

export interface IconProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** Material Symbols ligature name, e.g. `arrow_back`. */
  name: string;
  /** Accessible label. When omitted the icon is decorative (`aria-hidden`). */
  label?: string;
  /** Use the filled glyph variant. */
  filled?: boolean;
}

const FILLED_STYLE: CSSProperties = { fontVariationSettings: "'FILL' 1" };

export default function Icon({
  name,
  label,
  filled = false,
  className,
  style,
  ...rest
}: IconProps) {
  const path = !filled ? iconPaths[name] : undefined;
  return (
    <span
      {...rest}
      className={cn('material-symbols-outlined', className)}
      translate="no"
      data-nosnippet
      style={path ? { fontFamily: 'inherit', ...style } : filled ? { ...FILLED_STYLE, ...style } : style}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      {path ? (
        <svg aria-hidden="true" viewBox="0 -960 960 960" width="1em" height="1em" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
          <path d={path} />
        </svg>
      ) : name}
    </span>
  );
}
